import { searchRegexLanguageParser } from '../parser';
import { SearchQueryTermType } from '../types';

import { findCursorMatch, isCriterion, isGroupEnd, isGroupStart, isNotOperator } from './utils';

const NONE_ALLOWED = {
  [SearchQueryTermType.CRITERION]: false,
  [SearchQueryTermType.OPERATOR]: false,
} as const;

const ALL_ALLOWED = {
  [SearchQueryTermType.CRITERION]: true,
  [SearchQueryTermType.OPERATOR]: true,
} as const;

const CRITERION_ALLOWED = {
  [SearchQueryTermType.CRITERION]: true,
  [SearchQueryTermType.OPERATOR]: false,
} as const;

const OPERATOR_ALLOWED = {
  [SearchQueryTermType.CRITERION]: false,
  [SearchQueryTermType.OPERATOR]: true,
} as const;

export const getNextAllowedTermTypes = (
  rawQuery: string,
  cursorPosition: number,
  hasError?: boolean,
) => {
  if (rawQuery.length === 0) {
    return CRITERION_ALLOWED;
  }

  if (hasError && cursorPosition < rawQuery.length) {
    return NONE_ALLOWED;
  }

  const { query } = searchRegexLanguageParser.parse(rawQuery);
  const cursorMatch = findCursorMatch(query, cursorPosition, rawQuery);

  const isAtTermStart =
    cursorMatch?.term.startPosition !== undefined &&
    cursorMatch.term.startPosition === cursorPosition;

  const isAtTermEnd =
    cursorMatch?.term.endPosition !== undefined && cursorMatch.term.endPosition === cursorPosition;

  const isAtEnd = cursorPosition === rawQuery.length;

  if (query.length === 0) {
    return CRITERION_ALLOWED;
  }

  if (isGroupStart(cursorMatch?.term)) {
    if (isAtTermStart) {
      return OPERATOR_ALLOWED;
    }

    return CRITERION_ALLOWED;
  }

  if (isGroupEnd(cursorMatch?.term)) {
    if (isAtTermEnd) {
      return OPERATOR_ALLOWED;
    }

    return ALL_ALLOWED;
  }

  if (isNotOperator(cursorMatch?.term)) {
    return CRITERION_ALLOWED;
  }

  if (isCriterion(cursorMatch?.term)) {
    if (isAtEnd) {
      return ALL_ALLOWED;
    }

    return CRITERION_ALLOWED;
  }

  return ALL_ALLOWED;
};
